import { requestGet, requestPost, requestPut } from "../config/Api";

export const getBranches = (filters = {}) => {
  const params = new URLSearchParams();

  if (typeof filters.is_active === "boolean") {
    params.append("is_active", filters.is_active);
  }
  const query = params.toString();
  const url = query ? `branches?${query}` : "branches";
  return requestGet(url);
};

export const createBranch = (branch) => {
  return requestPost("branches", branch);
};

export const updateBranch = (id, branch) => {
  return requestPut(`branches/${id}`, branch);
};

